import {AbstractControl, FormGroup, ValidatorFn} from "@angular/forms";


export abstract class AbstractFlowHelperService {

  public form: FormGroup;
  public fieldToValidate: any = [];

  get formControls() {
    return this.form.controls;
  }

  public isAnyTouchedControlInvalid() {
    return this.fieldToValidate.some(key => {
      return this.form.get(key).touched && !this.form.get(key).valid;
    });
  }

  public isValidForm() {
    let isValid = true;
    if (this.containInvalidFields(this.fieldToValidate)) {
      this.validateForm(this.fieldToValidate);
      isValid = false;
    }
    return isValid;
  }

  protected containInvalidFields(fields) {
    return fields.some(key => {
      return !this.form.get(key).valid;
    });
  }

  protected validateForm(fieldsToValidate) {
    Object.keys(this.formControls).forEach(key => {
      if (fieldsToValidate.includes(key)) {
        let control = this.form.get(key);
        control.markAsTouched();
      }
    });
  }

  public numberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value !== undefined && !isNaN(control.value)) {
        return {'ageRange': true};
      }
      return null;
    };
  }

  public abstract buildForm();

}
